import React from 'react';
import QRCodeComponent from 'Utils/QRCodeComponent';
import { STATUS } from './MobileCameraConnector';
import styles from './QRPairingModal.module.css';

const STATUS_COPY = {
  [STATUS.WAITING]: 'Waiting for phone…',
  [STATUS.CONNECTING]: 'Connecting…',
  [STATUS.CONNECTED]: 'Mobile Connected',
  [STATUS.RECONNECTING]: 'Reconnecting…',
  [STATUS.DISCONNECTED]: 'Phone disconnected',
  [STATUS.TIMED_OUT]: 'Host not found on this network. Please connect both devices to the same WiFi and retry.',
  [STATUS.FAILED]: 'Connection failed',
};

const QRPairingModal = ({
  open,
  joinUrl,
  status,
  onClose,
  onRetry,
}) => {
  if (!open) return null;
  const copy = STATUS_COPY[status] || '';
  const isError = status === STATUS.TIMED_OUT || status === STATUS.FAILED || status === STATUS.DISCONNECTED;
  const isConnected = status === STATUS.CONNECTED;

  return (
    <div className={styles.modalRoot} role="dialog" aria-modal="true" aria-label="Pair your phone as a camera">
      <button
        type="button"
        className={styles.backdrop}
        onClick={onClose}
        aria-label="Close"
      />
      <div className={styles.card}>
        <button
          type="button"
          className={styles.closeBtn}
          onClick={onClose}
          aria-label="Close"
        >
          ✕
        </button>

        <div className={styles.header}>
          <h2 className={styles.title}>Use your phone as the camera</h2>
          <p className={styles.subtitle}>
            Scan this QR code from your phone to use it as camera
          </p>
        </div>

        {!isError && (
          <div className={styles.qrWrap}>
            {joinUrl ? <QRCodeComponent url={joinUrl} size={220} /> : null}
          </div>
        )}

        {!isError && joinUrl && (
          <div className={styles.urlRow}>
            <span className={styles.urlLabel}>Or open on your phone:</span>
            <code className={styles.urlValue}>{joinUrl}</code>
          </div>
        )}

        <div className={[
          styles.status,
          isError && styles.statusError,
          isConnected && styles.statusOk,
        ].filter(Boolean).join(' ')}
        >
          {!isError && !isConnected && (
            <span className={styles.spinner} aria-hidden="true" />
          )}
          {isConnected && (
            <span className={styles.dotOk} aria-hidden="true" />
          )}
          {copy}
        </div>

        <div className={styles.hints}>
          <span>1. Make sure both devices are on the same WiFi.</span>
          <span>2. Allow camera + microphone on your phone when prompted.</span>
        </div>

        <div className={styles.actions}>
          {isError && (
            <button type="button" className={styles.primaryBtn} onClick={onRetry}>
              Retry
            </button>
          )}
          <button type="button" className={styles.secondaryBtn} onClick={onClose}>
            {isConnected ? 'Done' : 'Cancel'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default QRPairingModal;
